import { Cloudinary } from '@cloudinary/url-gen'
import { createContext, PropsWithChildren, useContext, useState } from 'react'

const CloudinaryContext = createContext<Cloudinary | undefined>(undefined)

export const CloudinaryProvider = ({ children, cld: cloudinary }: PropsWithChildren<{ cld?: Cloudinary }>) => {
  const [cld] = useState(() => {
    return (
      cloudinary ||
      new Cloudinary({
        cloud: {
          cloudName: 'almanac',
        },
      })
    )
  })
  return <CloudinaryContext.Provider value={cld}>{children}</CloudinaryContext.Provider>
}

export const useCloudinary = () => useContext(CloudinaryContext)

const HOSTS = [
  'https://blaze-article-uploads.s3.us-west-1.amazonaws.com/',
  'https://almanac-article-uploads-for-dev.s3.us-west-1.amazonaws.com/',
  'https://blaze-media-uploads.s3.us-west-1.amazonaws.com/',
  'https://blaze-media-uploads-for-dev.s3.us-west-1.amazonaws.com/',
]

export const extractPublicIdFromUrl = (url: string) => {
  let extractedId = url
  HOSTS.forEach((host) => {
    extractedId = url.replace(host, '')
  })
  return `uploads/${extractedId}`
}
